exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReplyButton.-interactive{cursor:pointer}.ReplyButton.-interactive.-active,.ReplyButton.-interactive:hover{color:#0095ff;color:var(--cBlue,#0095ff)}", ""]);

// exports
